import { render } from "./confirmPay.vue?vue&type=template&id=1528a58e&lang=true"
import script from "./confirmPay.vue?vue&type=script&lang=js"
export * from "./confirmPay.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__